import React from 'react';

import { flagStyles } from '../settings';

const SvgBQ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-672px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBQ;
